export const PRODUCT = 'DIAGNOSTIC AUTOMOBILE PRO™'

export const PRODUCT_TAGLINE =
  'SYSTÈME PROFESSIONNEL DE DIAGNOSTIC, DÉTECTION DES PANNES ET RÉPARATION AUTOMOBILE'

/** Anchor id of the €27 purchase section */
export const OFFER_ANCHOR = '#offer'

export const CHECKOUT_URL = 'https://diagnostic-automobile.impultienda.ar/checkout'

const RES =
  'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/6ef8b7d0-add0-4022-bebe-6c939c2e9572/'

/** Box-set mockup (hero, €27 offer and final CTA). */
export const MOCKUP_IMAGE = RES + '1793845712378_mockup-automobile-ed34cf69.png'

export const RESOURCES_BASE = RES

export const SUPPORT_EMAIL = 'kitonline27@gmail.com'

export const PRICE = '27 €'
export const COMPARE_PRICE = '97 €'

/** Meta Pixel ID — DIAGNOSTIC AUTOMOBILE PRO (France), píxel 3. */
export const PIXEL_ID = '1849675162877026'
